import { fetchResource } from 'services/api';

const fetchUnitsOfMeasure = async () => {
  return await fetchResource(`/api/units-of-measure`);
};

export { fetchUnitsOfMeasure };
